import { useQuery, keepPreviousData } from '@tanstack/react-query';
import { AxiosInstance } from './auth/AxiosInstance';

const fetchDashboardStats = async () => {
  const { data } = await AxiosInstance.get('/admin-stats/dashboard');
  return data.data;
};

export const useGetDashboardStats = () => {
  return useQuery({
    queryKey: ['adminDashboardStats'],
    queryFn: fetchDashboardStats,
    refetchInterval: 5 * 60 * 1000, // Refresh every 5 minutes
    placeholderData: keepPreviousData,
  });
};

const fetchWeeklyRevenue = async () => {
  const { data } = await AxiosInstance.get('/admin-stats/weekly-revenue');
  return data.data;
};

export const useGetWeeklyRevenue = () => {
  return useQuery({
    queryKey: ['adminWeeklyRevenue'],
    queryFn: fetchWeeklyRevenue,
    refetchInterval: 5 * 60 * 1000,
  });
};

const fetchIncomeStats = async () => {
  const { data } = await AxiosInstance.get('/admin-stats/income-stats');
  return data.data;
};

export const useGetIncomeStats = () => {
  return useQuery({
    queryKey: ['adminIncomeStats'],
    queryFn: fetchIncomeStats,
    refetchInterval: 10 * 60 * 1000,
  });
};

const fetchOngoingProjects = async () => {
  const { data } = await AxiosInstance.get('/admin-stats/ongoing-projects');
  return data.data;
};

export const useGetOngoingProjects = () => {
  return useQuery({
    queryKey: ['adminOngoingProjects'],
    queryFn: fetchOngoingProjects,
    refetchInterval: 5 * 60 * 1000,
  });
};
